import React from 'react';
export function Footer() {
  const year = new Date().getFullYear();
  return <footer className="bg-forest-900 text-forest-50/60 py-12 px-4 text-center border-t border-forest-800" data-id="element-34">
      <div className="max-w-4xl mx-auto space-y-6" data-id="element-35">
        <div className="flex flex-wrap justify-center gap-6 text-sm" data-id="element-36">
          <a href="#" className="hover:text-gold-400 transition-colors" data-id="element-37">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-gold-400 transition-colors" data-id="element-38">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-gold-400 transition-colors" data-id="element-39">
            Contacto
          </a>
        </div>

        <p className="text-xs mt-8" data-id="element-40">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          <br data-id="element-41" />
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>

        <p className="text-sm font-medium" data-id="element-42">📩 soportetumundoglobal@gmail.com</p>

        <div className="text-sm space-y-1" data-id="element-43">
          <p data-id="element-44">&copy; {year} TU MUNDO GLOBAL. Todos los derechos reservados.</p>
          <p data-id="element-45">
            Protocolo Rescate SIBO™ es una marca registrada de TU MUNDO GLOBAL.
          </p>
        </div>
      </div>
    </footer>;
}